import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconExpandContentLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 17h3.25c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534.726.726 0 0 1-.216.535.726.726 0 0 1-.534.215H6.404a.874.874 0 0 1-.644-.26.874.874 0 0 1-.26-.644V13.75c0-.213.072-.39.216-.534A.726.726 0 0 1 6.25 13c.213 0 .391.072.535.216A.726.726 0 0 1 7 13.75V17ZM17 7h-3.25a.726.726 0 0 1-.534-.216A.726.726 0 0 1 13 6.25c0-.213.072-.391.216-.535a.726.726 0 0 1 .534-.215h3.846c.256 0 .47.087.644.26.173.173.26.388.26.644v3.846c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216.725.725 0 0 1-.535-.216.726.726 0 0 1-.215-.534V7Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconExpandContentLine;
